import { Component } from '@angular/core';

@Component({
  selector: 'globot-ready-account',
  templateUrl: './ready-account.component.html',
  styleUrls: ['./ready-account.component.scss'],
})
export class ReadyAccountComponent {
  options = {
    path: '/assets/lotties/check.json',
  };
}
